import { render, staticRenderFns } from "./FbFileView.vue?vue&type=template&id=cdec784e&scoped=true"
import script from "./FbFileView.vue?vue&type=script&lang=js"
export * from "./FbFileView.vue?vue&type=script&lang=js"
import style0 from "./FbFileView.vue?vue&type=style&index=0&id=cdec784e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdec784e",
  null
  
)

export default component.exports